import { type CookieConsentConfig } from 'vanilla-cookieconsent'

type Props = {
	onAcceptService: (service: string) => () => void
	onRejectService: (service: string) => () => void
}

export const getConsentConfig = ({ onAcceptService, onRejectService }: Props): CookieConsentConfig =>
	({
		root: 'body',
		autoShow: true,
		mode: 'opt-in',
		guiOptions: {
			consentModal: {
				layout: 'box',
				position: 'bottom right',
				equalWeightButtons: true
			},
			preferencesModal: {
				layout: 'box',
				equalWeightButtons: true
			}
		},
		categories: {
			necessary: {
				enabled: true,
				readOnly: true
			},
			marketing: {
				enabled: false,
				services: {
					absoluteLabs: {
						label: 'Absolute Labs',
						onAccept: onAcceptService('absolute-labs'),
						onReject: onRejectService('absolute-labs')
					}
				}
			},
			preferences: {
				enabled: false,
				readOnly: false
			},
			statistics: {
				enabled: false,
				readOnly: false
			}
		},
		language: {
			default: 'en',
			translations: {
				en: {
					consentModal: {
						title: 'Manage Cookie Consent',
						description:
							'To provide the best experiences, HX Entertainment Ltd. use technologies like cookies to store and/or access device information. Consenting to these technologies will allow HX Entertainment Ltd. to process data such as browsing behaviour or unique IDs on this site. Not consenting or withdrawing consent, may adversely affect certain features and functions.',
						acceptAllBtn: 'Accept All',
						acceptNecessaryBtn: 'Reject All',
						showPreferencesBtn: 'Manage preferences',
						footer: `
            <a href="https://www.chiliz.com/chiliz-chain/cookie-policy/" target="_blank" class="consent-link">Cookies Policy</a>
            <a href="https://www.chiliz.com/chiliz-chain/privacy-policy/" target="_blank" class="consent-link">Privacy Policy</a>
        `
					},
					preferencesModal: {
						title: 'Manage Cookie Preferences',
						acceptAllBtn: 'Accept All',
						acceptNecessaryBtn: 'Reject All',
						savePreferencesBtn: 'Accept current selection',
						closeIconLabel: 'Close modal',
						serviceCounterLabel: 'Service|Services',
						sections: [
							{
								description: `To provide the best experiences, HX Entertainment Ltd. use technologies like cookies to store and/or access device information. Consenting to these technologies will allow HX Entertainment Ltd. to process data such as browsing behaviour or unique IDs on this site. Not consenting or withdrawing consent, may adversely affect certain features and functions.`
							},
							{
								title: 'Functional',
								description:
									'The technical storage or access is strictly necessary for the legitimate purpose of enabling the use of a specific service explicitly requested by the subscriber or user, or for the sole purpose of carrying out the transmission of a communication over an electronic communications network.',
								linkedCategory: 'necessary'
							},
							{
								title: 'Preferences',
								description:
									'The technical storage or access is necessary for the legitimate purpose of storing preferences that are not requested by the subscriber or user.',
								linkedCategory: 'preferences'
							},
							{
								title: 'Statistics',
								description:
									'The technical storage or access that is used exclusively for anonymous statistical purposes. Without a subpoena, voluntary compliance on the part of your Internet Service Provider, or additional records from a third party, information stored or retrieved for this purpose alone cannot usually be used to identify you.',
								linkedCategory: 'statistics'
							},
							{
								title: 'Marketing',
								description:
									'The technical storage or access is required to create user profiles to send advertising, or to track the user on a website or across several websites for similar marketing purposes.',
								linkedCategory: 'marketing'
							}
						]
					}
				}
			}
		}
	})
